<template>
    <div class="padding-10px">
        <el-card class="box-card" shadow="none" style="min-height: 500px;">
            <el-form :model="articleForm" ref="articleForm" :rules="articleFormRules" label-width="120px" size="medium"
                style="padding-right: 10%;" class="demo-form-inline">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="排序" prop="sort">
                            <el-input-number clearable v-model="articleForm.sort" :min="1"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="标题">
                            <el-input v-model="articleForm.title"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="内容">
                    <writings-edit v-on:listenToChildEvent="showMsgFromEdit"
                        :parent-content="articleForm.content"></writings-edit>
                </el-form-item>
                <el-form-item style="padding: 0; margin: 0;">
                    <el-button
                        @click="linkTo('/popularize/writings/list')">&nbsp;&nbsp;&nbsp;取&nbsp;&nbsp;消&nbsp;&nbsp;&nbsp;</el-button>
                    <el-button type="primary" :loading='loading'
                        @click="submitArticleForm('articleForm')">&nbsp;&nbsp;&nbsp;确&nbsp;&nbsp;定&nbsp;&nbsp;&nbsp;</el-button>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>

<script>
import writingsEdit from "../../../components/plugins/edit/writingsEdit";
import { reqCode, dialogAction } from '@/common/const';
export default {
    name: "writingsAdd",
    components: {
        writingsEdit,
    },
    data() {
        return {
            selectedChannels: [],
            articleForm: {
                sort: 1,
                content: `<br/> `
            },
            articleFormRules: {},
            channels: [],
            createTime: [],
            hideThumbnail: false,
            dialogAction: '',
            articleSelectVal: -1,
            thumbnailLimit: 1,
            thumbnailFileList: [],
            loading: false
        }
    },
    created() {
        this.dialogAction = this.$route.params.action;
        if (dialogAction.EDIT == this.dialogAction) {
            this.articleForm = JSON.parse(this.$route.params.data);
        }
    },
    mounted() {
    },
    methods: {
        articleSelectChange(val) {
            this.articleSelectVal = val;
            this.articleForm.status = val;
        },
        linkTo(url) {
            this.$router.push({ path: url });
        },
        show(data) {
            console.log(data);
            console.log(this.selectedChannels);
        },
        showMsgFromEdit(data) {
            this.articleForm.content = data;
        },
        addArticle(formName, reqParam) {
            this.loading = true
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$http.post(this.env.apiUrl + '/api/popularize/writings/add', reqParam, {
                        headers: {
                            accessToken: sessionStorage.getItem('accessToken')
                        }
                    }).then(resp => {
                        this.loading = false
                        let data = resp.data;
                        console.log(data.code)
                        if ('success' === data.code) {
                            this.$message({
                                message: '新增海报文章成功',
                                type: 'success'
                            });
                            this.linkTo('/popularize/writings/list');
                        } else {
                            this.$alert('' + data.message, '错误提示', {
                                confirmButtonText: '确定',
                            });
                        }
                    }).catch(e => {
                        this.$alert('' + e, '错误提示', {
                            confirmButtonText: '确定',
                        });
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        submitArticleForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let reqParam = {
                        title: this.articleForm.title,
                        content: this.articleForm.content,
                        sort: this.articleForm.sort,
                    };
                    this.addArticle(formName, reqParam);
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$nextTick(() => {
                this.createTime = [];
                this.articleForm = {
                    sort: 1,
                    content: `<br/>`
                };
                this.$refs[formName].resetFields();
            })
        },
    },
    destroyed() {
    }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/popularize/writings/writingsAdd.vue